import { PaymentStatus } from "models/payment/PaymentStatus"
import { IConfirmarPagamento, IConfirmarPagamentoResponse } from "../../../models/payment/IPaymentApi"
import { IPayOrRecharge } from "../../../models/payment/IPayOrRecharge"
import api from "../Api"
import { IGetAddressResponse } from "models/paymentLink/IGetAddressResponse"
import { IPixInfo } from "../../../models/payment/IPixInfo";

export const PaymentApi = () => {
    const confirmarPagamentoPedido = async (paymentRequest: IConfirmarPagamento) => {
        const response = await api.post<IConfirmarPagamentoResponse>("/vendas/confirmarPagamento", paymentRequest)
        return response
    }
    const confirmarPagamentoPedidoMeepCard = async (paymentRequest: IConfirmarPagamento) => {
        const response = await api.post<IConfirmarPagamentoResponse>("/vendas/confirmarPagamento", paymentRequest, { headers: { Authorization: "" } })
        return response
    }
    const confirmCommandPayment = async (paymentRequest: IConfirmarPagamento) => {
        return await api.post<IConfirmarPagamentoResponse>("/vendas/CommandPayment", paymentRequest);
    }
    const payOrRecharge = async (payOrRecharge: IPayOrRecharge) => {
        const response = await api.post("/SuperApp/LiveUser/PayOrRecharge", payOrRecharge)
        return response
    }
    const getPaymentStatus = async (orderId: string): Promise<{ id: PaymentStatus }> => {
        const response = await api.get<{ Id: PaymentStatus }>("/PedidoPOS/PaymentStatus/" + orderId)
        return { id: response.data.Id }
    }
    const getPixStatus = async (paymentId: string) => {
        return await api.get<IPixInfo>(`/public/Pix/${paymentId}`)
    }
    const getAddress = async (postalAddressCode: string): Promise<IGetAddressResponse> => {
        const response = await api.get<IGetAddressResponse>("/address/postal-address-code/" + postalAddressCode)
        return response.data
    }
    const checkClosing = async (pedidoId: string) => {
        const response = await api.post("/vendas/CommandPayment/CheckClosing", { pedidoId: pedidoId })
        return response.data
    }

    return {
        confirmarPagamentoPedido,
        payOrRecharge,
        confirmarPagamentoPedidoMeepCard,
        getPaymentStatus,
        getAddress,
        getPixStatus,
        confirmCommandPayment,
        checkClosing 
    }
}
